const HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache': 'no-cache'
};

function fetchRequest(method, path, body = null) {
    return fetch("api" + path, {
        method: method,
        headers: HEADERS,
        body: (body !== undefined && body !== null) ? JSON.stringify(body) : null,
        credentials: 'include'
    }).then((res) => {
        if (!res.ok) {
            throw new Error(res.status);
        }
        return res.text().then(function (text) {
            return text ? JSON.parse(text) : {}
        })
    });
};

export default fetchRequest;